import React from "react";
import Futter from "../futter/Futter";
import s from "./services.module.css";
//import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function Services() {
  //const navigate = useNavigate();

  return (
    <div>
      <Helmet>
        <title>Дистанционный съем | Поверка счетчиков</title>
        <meta
          name="description"
          content="Услуги по дистанционному съему показаний и поверке счетчиков воды и тепла."
        />
      </Helmet>

      <div className={s.services}>
        <div className={s.container}>
          <div className={s.servicesBlock}>
            <h2
              style={{ position: "sticky", top: "20px" }}
              className={s.servicesTitle}
            >
              Услуги
            </h2>

            <div className={s.servicesCards}>
              <div className={s.card}>
                <h3>Дистанционный съем показаний</h3>
                <p className={s.servicesText}>
                  Услуга дистанционного съёма показаний со счётчиков воды и тепла
                  обеспечивает автоматическую фиксацию данных приборов учёта и их
                  последующую передачу в «Минскводоканал» или обслуживающую
                  организацию.
                </p>
              </div>

              <div className={s.card}>
                <h1>Поверка счетчиков воды и тепла</h1>
                <p className={s.servicesText}>
                  Осуществляем профессиональную поверку счётчиков воды и тепла
                  диаметром Ду15 и Ду20 с предоставлением официальных документов
                  по результатам работ, что гарантирует законность и точность
                  учёта ваших приборов.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Futter />
    </div>
  );
}
